import { render } from "./ExpiredSubscription.vue?vue&type=template&id=664a248d&scoped=true"
import script from "./ExpiredSubscription.vue?vue&type=script&lang=js"
export * from "./ExpiredSubscription.vue?vue&type=script&lang=js"

import "./ExpiredSubscription.vue?vue&type=style&index=0&id=664a248d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664a248d"]])

export default __exports__